import React, { FC, ReactNode } from "react"
import { BodyWithRightSidebarLayout } from "../views/atoms/layouts/BodyWithRightSidebarLayout"
import { CarrotExpertsModule } from "../views/molecules/CarrotExpertsModule"
import { SideBarBase } from "components/views/atoms/SidebarBase"
import { TalkToCarrotChatHeader } from "./TalkToCarrotChatHeader"
import { SendMessageDescription } from "./send-message/useSendMessageTranslator"
import { Typography } from "@carrotfertility/carotene-core"
import { PageLayout } from "features/global-ui/page-layout"

type TalkToCarrotLayoutProps = {
  subtitle: string
  description: SendMessageDescription
  children: ReactNode
  sidebar?: ReactNode
}

const TalkToCarrotLayout: FC<TalkToCarrotLayoutProps> = ({
  subtitle,
  description,
  children,
  sidebar = <ChatSideBar />
}: TalkToCarrotLayoutProps) => (
  <PageLayout header={<TalkToCarrotChatHeader />}>
    <BodyWithRightSidebarLayout sidebar={sidebar}>
      <Typography
        variant="h2"
        color={(theme) => theme.palette.text.secondary}
        marginBottom={(theme) => theme.tokens.spacing.md}
      >
        {subtitle}
      </Typography>
      <Typography
        variant="body1"
        color={(theme) => theme.palette.text.secondary}
        marginBottom={(theme) => theme.tokens.spacing.xxxl}
      >
        {description}
      </Typography>
      {children}
    </BodyWithRightSidebarLayout>
  </PageLayout>
)

const ChatSideBar: FC = () => (
  <SideBarBase>
    <CarrotExpertsModule />
  </SideBarBase>
)

export { TalkToCarrotLayout }
